/*
 * Success store: This file store shows success message in the application.
 */

import { types,ModelInstanceTypeProps,ModelProperties } from 'mobx-state-tree';
import { ISuccessObject } from '../../common/components/success-manager/ISuccessManagerInterface';


/** 
 * @description Success Model Initialization
 */
export const CQSuccessModel = types.model({
    successMessage: types.string,
    componentName: types.string,
    successFlag: types.boolean,
})
    .actions((self: ModelInstanceTypeProps<ModelProperties>) => ({
        dispatchError(error: ISuccessObject) {
            self.successMessage = error.successMessage;
            self.componentName = error.componentName;
            self.successFlag = true;
        },
        hide() {
            self.successFlag = false;
        }
    }));
    
